import { Callout } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";

export function WarningCallout() {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <Callout
        iconType="triangle-exclamation"
        title=""
        sx={{
          backgroundColor: (theme) => theme.palette.shift?.urgent.background,
          color: (theme) => theme.palette.shift?.urgent.text,
          width: 40,
          height: 26,
          paddingLeft: 4,
        }}
      />
    </Box>
  );
}
